import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  forwardRef, HostBinding, Inject, Injector, INJECTOR,
  Input,
  OnInit, Optional,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  NgControl
} from "@angular/forms";
import {INT_TESTING_DATA_MARKERS_TOKEN} from "../../tokens";
import {IntTestingDataMarkers} from "../../types";

@Component({
  selector: 'int-default-checkbox',
  templateUrl: './int-default-checkbox.component.html',
  styleUrls: ['./int-default-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IntDefaultCheckboxComponent),
      multi: true
    }
  ]
})
export class IntDefaultCheckboxComponent implements OnInit, ControlValueAccessor {
  @Input() size = "md";
  @Input() disabled = false;
  @Input() checked = false;
  @Input() readonly = false;
  @Input() value: string | number = '';
  @Input() type: string = 'checkbox';
  @Input() name: string | null = null;
  @Input() labeled: boolean = true;
  @Input() indeterminate: boolean = false;
  @Input() fieldTestMark: string | null = null;
  @Input() fieldAddedTestMark: string | null = null;

  control!: NgControl;

  constructor(
    protected host: ViewContainerRef,
    protected renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    @Inject(INJECTOR) private injector: Injector,
    @Optional()
    @Inject(INT_TESTING_DATA_MARKERS_TOKEN) readonly testingMarkers: IntTestingDataMarkers
  ) { }

  @HostBinding('attr.data-checkbox-status') get _cs() {
    return this.indeterminate ? 'indeterminate' : this.checked ? 'checked' : 'unchecked';
  }

  setControl() {
    try {
      this.control = this.injector.get(NgControl);
    }catch (err) {
      console.log('please provide NgControl for [IntDefaultCheckboxComponent]')
    }
  }

  private onChange(status: boolean) {
    //this.checked = status;
  }

  handleChange(value: Event): any {
    const _value = (value.target as any).checked;
    this.checked = _value;
    this.onChange(_value);
    this.onTouched();
    this.cdr.markForCheck();
  }

  onTouched() {}

  writeValue(value: any): void {
    this.checked = Boolean(value);
    //this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
    const element = this.host.element.nativeElement;
    const propsList = [
      this.size
    ];
    propsList.forEach((prop: string) => {
      this.renderer.addClass(element, prop);
    });

    this.setControl();
  }
}
